import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MVDNowViewService {
    public documentSelected: VoidFunction;
    public messageSelected: VoidFunction;
    public titleSelected: (number) => void;

    public showDetailView = true;
    public showTitleView = false;
    public selectedVehicleId: number;

    public customerNumberSubject: BehaviorSubject<number> = new BehaviorSubject<number>(null);

    public showTitle(vehicleId): void {
        this.selectedVehicleId = vehicleId;
        this.showDetailView = false;
        this.showTitleView = true;
    }

    public showDetail(): void {
        this.selectedVehicleId = null;
        this.showDetailView = true;
        this.showTitleView = false;
    }

}
